/**
 * Created by Ning Jiang on 3/20/2017.
 */

import { BarbarianFuryServerDataParser } from "../BarbarianFuryServerDataParser";
import { IBarbarianFuryGameData } from "./IBarbarianFuryServerData";
import { BarbarianFuryGameMode } from "../../gamemode/BarbarianFuryGameMode";
import { SpinParsedGameData } from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";

export class BarbarianFuryParsedGameData extends SpinParsedGameData {

    private readonly _stackedSpinTriggered: boolean;
    private readonly _activeStackedSymbol: string;
    private readonly _initialStackOverlay: boolean[];
    private readonly _stackOverlay: boolean[][];
    private readonly _doReelNudge: boolean[];
    private readonly _doScatterNudge: boolean[];
    private readonly _extraSymbolsOnTop: string[][];
    private readonly _stackedModeSymbolInWin: boolean[];
    private readonly _overlayWildInRespin: boolean[];
    private readonly _freespinMultiplier: number;
    private readonly _stackedSpinTease: boolean;
    private readonly _stackedSymbolNudgeTriggered: boolean;
    private readonly _isRestoreState: boolean;

    public get stackedSpinTriggered(): boolean {
        return this._stackedSpinTriggered;
    }

    public get activeStackedSymbol(): string {
        return this._activeStackedSymbol;
    }

    public get initialStackOverlay(): boolean[] {
        return this._initialStackOverlay;
    }

    public get stackOverlay(): boolean[][] {
        return this._stackOverlay;
    }

    public get doReelNudge(): boolean[] {
        return this._doReelNudge;
    }

    public get doScatterNudge(): boolean[] {
        return this._doScatterNudge;
    }

    public get extraSymbolsOnTop(): string[][] {
        return this._extraSymbolsOnTop;
    }

    public get stackedModeSymbolInWin(): boolean[] {
        return this._stackedModeSymbolInWin;
    }

    public get overlayWildInRespin(): boolean[] {
        return this._overlayWildInRespin;
    }

    public get freeSpinMultiplier(): number {
        return this._freespinMultiplier;
    }

    public get stackedSpinTease(): boolean {
        return this._stackedSpinTease;
    }

    public get stackedSymbolNudgeTriggered(): boolean {
        return this._stackedSymbolNudgeTriggered;
    }

    public get isRestoreState(): boolean {
        return this._isRestoreState;
    }

    //added below code for displaying total win in stacked respin.
    protected isFeatureTotalWin(): boolean {
        return (this.mode === BarbarianFuryGameMode.STACKED_RESPIN);
    }

    constructor(rawData: IBarbarianFuryGameData, dataParser: BarbarianFuryServerDataParser) {
        super(rawData, dataParser);

        this._stackedSpinTriggered = dataParser.parseStackedSpinTriggered(rawData);
        this._activeStackedSymbol = dataParser.parseActiveStackedSymbol(rawData);
        this._initialStackOverlay = dataParser.parseInitialStackOverlay(rawData);
        this._stackOverlay = dataParser.parseStackOverlay(rawData);
        this._freespinMultiplier = rawData.freespinMultiplier;
        this._doReelNudge = dataParser.parseDoReelNudge(rawData);
        this._doScatterNudge = dataParser.parseDoScatterNudge(rawData);
        this._extraSymbolsOnTop = dataParser.parseExtraSymbolsOnTop(rawData);
        this._stackedModeSymbolInWin = dataParser.parseStackedModeSymbolInWin(rawData);
        this._overlayWildInRespin = dataParser.parseOverlayWildInRespin(rawData);
        this._stackedSpinTease = rawData.stackedSpinTease;
        this._stackedSymbolNudgeTriggered = rawData.stackedSymbolNudgeTriggered;
        this._isRestoreState = rawData.isRestoreState;
    }
}